import * as React from "react";
import * as ComponentBase from "DistributedTaskControls/Common/Components/Base";
import { VariablesTabSharedView } from "DistributedTaskControls/SharedViews/ContainerTabs/VariablesTab/VariablesTabSharedView";
import { VariablesTabItemsUtils } from "PipelineWorkflow/Scripts/Shared/ContainerTabs/VariablesTab/VariablesTab";

export interface IVariablesTabAsyncLoadProps extends ComponentBase.IProps {
    hasVariableGroups: boolean;
    onPublishTelemetry: () => void;
}

export class VariablesTabAsyncLoad extends ComponentBase.Component<IVariablesTabAsyncLoadProps, ComponentBase.IStateless>{

    constructor(props: IVariablesTabAsyncLoadProps) {
        super(props);
    }

    public render(): JSX.Element {
        return ( <VariablesTabSharedView
            leftFooter={VariablesTabItemsUtils.getPreDefinedLinkComponent()}
            defaultItems={VariablesTabItemsUtils.getVariablesTabItems(null, !this.props.hasVariableGroups, false)}
            onPublishTelemetry={this.props.onPublishTelemetry} />
        );
    }
}